import BulkUploadEvInventory from "../../../views/BulkUploadEvInventory.js";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const BulkUploadEvInventoryRoutes = [
  {
    menuName: MenuNames.EV_INVENTORY,
    path: "/bulk-upload-ev-inventory",
    component: BulkUploadEvInventory,
    exact: true,
  },
];

export default BulkUploadEvInventoryRoutes;
